import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b68b1e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-line" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, [
    /*#__PURE__*/_createTextVNode("Join Us - Latest "),
    /*#__PURE__*/_createElementVNode("span", { class: "color" }, "Open"),
    /*#__PURE__*/_createTextVNode(" Positions!")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "title-text" }, " We're always looking for talented and crazy smart people! ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { id: "position-list" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "show-more"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    id: "positions",
    class: _normalizeClass({inverted: _ctx.inverted})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.positionsToShow, (position) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: `${position.title}-${position.short}`,
            class: "position",
            to: {
            name: 'Position',
            params: {
              position: _ctx.genPositionUrl(position.title, position.short),
            },
          }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h4", null, _toDisplayString(position.title), 1),
                _createElementVNode("p", null, _toDisplayString(position.short), 1)
              ]),
              _createElementVNode("img", {
                class: "icon",
                src: require('@/assets/img/direction_ico.svg')
              }, null, 8, _hoisted_6)
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128)),
        (_ctx.positions.length > _ctx.positionsToShow.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_router_link, {
                class: "btn",
                to: "/career/#positions"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" See all positions ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}